import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import Text from '../../elementals/text'
import SubLabel from './subLabel'
import FieldTooltip from './fieldTooltip'
import styles from './styles.scss'
const cx = classnames.bind(styles)

/**
 * New label approach introduced early 2022 to show a label with subLabel help text
 * This also is to support standard label style for checkboxes which we've never had until now.
 * Note: even though this is called "CheckboxLabel" it also supports RadioField which is very similar.
 */
const CheckboxLabel = ({
  label,
  subLabel,
  compact = false,
  checkboxType,
  elmId = 'field',
  showAnchor = false,
  helpContent,
}) => {
  const options = {
    size: compact ? 'tiny' : 'small',
  }
  if (checkboxType === 'CHECKBOX') {
    options.weight = compact ? 'normal' : 'heavy'
    options.color = compact ? 'grayDark' : 'gray'
  } else {
    // radio
    options.weight = 'normal'
    options.color = 'grayDark'
  }

  return (
    <>
      <label className={cx('checkbox')}>
        {typeof label === 'string' ? (
          <Text
            className={cx('label', { compact })}
            {...options}
            data-elm-id={`${elmId}_label`}
          >
            {label}
          </Text>
        ) : (
          label
        )}
        {showAnchor && (
          <div className={cx('tooltip')}>
            <FieldTooltip
              elmId={`${elmId}_tooltip`}
              helpContent={helpContent}
              showAnchor={showAnchor}
              label={label}
              inverted
            />
          </div>
        )}
        <SubLabel
          label={subLabel}
          compact={compact}
          className={cx('sub-label')}
          elmId={elmId}
        />
      </label>
    </>
  )
}

CheckboxLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  compact: PropTypes.bool,
  checkboxType: PropTypes.oneOf(['checkbox', 'radio']),
  elmId: PropTypes.string,
  showAnchor: PropTypes.bool,
  helpContent: PropTypes.string,
}

export default CheckboxLabel
